import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    {/* Resource Cards Block */}
    <TitleBlock slots="heading" theme="lightest" className="titleBlock-align-left" mdxType="TitleBlock" />
    <h2 {...{
      "id": "use-cases-for-pdf-services-api"
    }}>{`Use cases for PDF Services API`}</h2>
    <ResourceCard slots="link, image, heading, text" theme='lightest' width="25%" className="useCaseCard" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "/document-services/use-cases/content-publishing/on-demand-report-creation"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "238px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100.84033613445378%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/0c4f49c6f27d4b609720997aa5e8073a/24599/report-creation-editing.webp 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/0c4f49c6f27d4b609720997aa5e8073a/a6b7e/report-creation-editing.jpg 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/0c4f49c6f27d4b609720997aa5e8073a/a6b7e/report-creation-editing.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "report-creation-and-editing"
    }}>{`Report creation and editing`}</h3>
    <p>{`Create and embed reports for internal or external consumption, sharing, and review.`}</p>
    <ResourceCard slots="link, image, heading, text" theme='lightest' width="25%" className="useCaseCard" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "/document-services/use-cases/archiving-and-retrieval/search-and-indexing/"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "238px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100.84033613445378%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/8e2a0ee52e73aed3817a091ffd3db60f/24599/searching-and-indexing.webp 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/8e2a0ee52e73aed3817a091ffd3db60f/a6b7e/searching-and-indexing.jpg 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/8e2a0ee52e73aed3817a091ffd3db60f/a6b7e/searching-and-indexing.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "search-and-indexing"
    }}>{`Search and Indexing`}</h3>
    <p>{`Create searchable indexes from digital documents to quickly locate critical content for compliance and other downstream processing.`}</p>
    <ResourceCard slots="link, image, heading, text" theme='lightest' width="25%" className="useCaseCard" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "/document-services/use-cases/content-publishing/digital-content-publishing/"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "238px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100.84033613445378%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/387059390ad53e74146f9a5a77bfa7e3/24599/content-republishing.webp 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/387059390ad53e74146f9a5a77bfa7e3/a6b7e/content-republishing.jpg 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/387059390ad53e74146f9a5a77bfa7e3/a6b7e/content-republishing.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "digital-content-publishing"
    }}>{`Digital content publishing`}</h3>
    <p>{`Publish whitepapers and marketing content with end-user interactivity, security controls, and analytics.`}</p>
    <ResourceCard slots="link, image, heading, text" theme='lightest' width="25%" className="useCaseCard" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "/document-services/use-cases/content-publishing/job-posting/"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "238px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100.84033613445378%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/fbd3d37774d2ed9eccd6ffe297c00dc4/24599/job-posting.webp 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/fbd3d37774d2ed9eccd6ffe297c00dc4/a6b7e/job-posting.jpg 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/fbd3d37774d2ed9eccd6ffe297c00dc4/a6b7e/job-posting.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "job-posting"
    }}>{`Job posting`}</h3>
    <p>{`Automate job posting with supporting documents such as PDF brochures, relevant job supplements, and company details.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      